import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import Item from '../item/Item';

const propTypes = {
  locale: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  extra: PropTypes.array.isRequired,
};

const Menu = (props) => {
  const items = props.items.map((item) => {
    const to = item[props.locale];
    const name = (
      <FormattedMessage
        id={item.name}
        description="Menu item"
      />
    );

    return <Item key={item.name} to={to}>{name}</Item>;
  });

  const extra = (
    <div className="right menu">
      {props.extra.map((item) => {
        const to = item[props.locale];
        const name = (
          <FormattedMessage
            id={item.name}
            description="Menu item"
          />
        );
        return <Item key={item.name} to={to}>{name}</Item>;
      })}
    </div>
  );

  return (
    <nav className="ui mini secondary pointing blue menu">
      {items}
      {extra}
    </nav>
  );
};

Menu.propTypes = propTypes;

export default Menu;



/** WEBPACK FOOTER **
 ** ./src/components/layout/nav/menu/Menu.js
 **/